import PendingAlertsAPI from 'dashboard/api/pendingAlerts';

const state = {
  items: [],
  isPolling: false,
};

const getters = {
  getAlerts: $state => $state.items,
  highestPriorityAlert: $state => {
    return $state.items.find(alert => alert.show_popup) || null;
  },
};

const actions = {
  async fetchAlerts({ commit }) {
    try {
      const response = await PendingAlertsAPI.getPendingAlerts();
      commit('setAlerts', response.data);
    } catch (error) {
      console.error('Error fetching pending alerts:', error);
    }
  },

  async suppressAlert({ commit, dispatch }, { conversationId, alertRuleId }) {
    try {
      // Oculta apenas o popup central localmente, mantendo a conversa na fila lateral
      commit('suppressPopup', conversationId);
      await PendingAlertsAPI.suppressAlert(conversationId, alertRuleId);
      // Opcional: Re-buscar fila imediatamente após sucesso
      dispatch('fetchAlerts');
    } catch (error) {
      console.error('Error suppressing alert:', error);
    }
  },

  startPolling({ commit, dispatch, state }) {
    if (state.isPolling) return;
    commit('setPolling', true);
    
    // Busca inicial imediata
    dispatch('fetchAlerts');

    // Polling a cada 15 segundos
    window.alertQueueInterval = setInterval(() => {
      dispatch('fetchAlerts');
    }, 15000);
  },

  stopPolling({ commit }) {
    commit('setPolling', false);
    if (window.alertQueueInterval) {
      clearInterval(window.alertQueueInterval);
      window.alertQueueInterval = null;
    }
  },
};

const mutations = {
  setAlerts($state, alerts) {
    $state.items = alerts;
  },
  removeAlert($state, conversationId) {
    $state.items = $state.items.filter(item => item.conversation.id !== conversationId);
  },
  suppressPopup($state, conversationId) {
    const item = $state.items.find(i => i.conversation.id === conversationId);
    if (item) {
      item.show_popup = false;
    }
  },
  setPolling($state, status) {
    $state.isPolling = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
